import { useContext } from 'react';
import { StudyContext } from '../../page/studies/:id/StudyContext';
import { useParams } from 'react-router-dom';

export interface StudyDesignerBaseEventData {
    studyId: string | undefined;
}

const useStudyDesignerBaseEventData = (): StudyDesignerBaseEventData => {
    const { studyId: contextStudyId } = useContext(StudyContext);
    const params = useParams();

    // Extract studyId from the wildcard parameter
    const paramsStudyIdWildcard = params['*']?.split('/')[0];

    const paramsStudyId = params.studyId ?? paramsStudyIdWildcard;

    const studyId = contextStudyId ?? paramsStudyId;

    if (!studyId) {
        console.error('No studyId found in context or params for analytics study designer base event data');
    }

    return { studyId };
};

export { useStudyDesignerBaseEventData };
